import { render } from "./LogoView.vue?vue&type=template&id=7dfe9c81"
const script = {}

import "./LogoView.vue?vue&type=style&index=0&id=7dfe9c81&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__